import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { GET_DOCUMENTOS_SAP } from "../../../data/graphQL/queries/DocumentosSAP/getDocumentosSAP";

export const useGetRows = (filters, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);

  const [getDocumentosSAP, { loading: documentossapLoading, data: dataDocumentosSAP }] = useLazyQuery(GET_DOCUMENTOS_SAP, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (dataDocumentosSAP) {
      const documentos = dataDocumentosSAP.documentosSap?.valorEsperado || [];
      setRows(documentos);
      setIsRefetchRequired(false);
    }
  }, [dataDocumentosSAP]);

  const handleSearch = useCallback((firstRender) => {
    if (!filters?.idEstado) {
      if (!firstRender) toast.error("Debe seleccionar un estado para realizar la búsqueda");
      return;
    }

    getDocumentosSAP({
      variables: {
        idEstado: filters.idEstado,
        numeroDoc: filters.numeroDoc,
        fechaDesde: filters.fechaDesde,
        fechaHasta: filters.fechaHasta,
      }
    })
    .then(({ error }) => {        
      if (error) {
        toast.error("Error al obtener los documentos SAP.");
        return;
      }
  }).catch((error) => {               
    toast.error("Error al obtener los documentos SAP.");
  });
  }, [filters, getDocumentosSAP]);

  return {
    rows,
    setRows,
    loading: documentossapLoading,
    totalCount: rows?.length || 0,
    handleSearch
  };
};